(function(){
  'use strict';
  const DATA = window.WCTableData || [];
  const LABELS = {
    occasion:{date:'Date Night',friends:'Freunde kommen vorbei',aperitivo:'Aperitivo',dinner:'gemeinsames Dinner',brunch:'Frühstück oder Brunch',morning_after:'der Morgen danach',spontaneous:'spontaner Abend'},
    time:{m15:'maximal 15 Minuten',m30:'etwa 30 Minuten',m60:'bis zu 60 Minuten',flex:'Zeit spielt keine Rolle'},
    vibe:{mediterranean:'mediterran',sharing:'Fingerfood & Sharing',comfort:'Comfort Food',fresh:'frisch & leicht',brunch:'Frühstück & Brunch',surprise:'überrasch mich'},
    drink:{aperitivo:'Aperitivo',cocktail:'Cocktail',wine:'Wein',beer:'Bier',alcoholfree:'alkoholfrei',open:'noch offen'},
    diet:{none:'nichts',vegetarian:'vegetarisch',vegan:'vegan',no_alcohol:'ohne Alkohol',lactose_low:'möglichst laktosearm'},
    budget:{b10:'bis 10 €',b20:'bis 20 €',b35:'bis 35 €',flex:'Budget ist zweitrangig'}
  };
  const TIME_CAP={m15:15,m30:30,m60:60,flex:999};
  const BUDGET_CAP={b10:10,b20:20,b35:35,flex:999};
  const URL_KEYS={occasion:'o',people:'n',time:'t',vibe:'v',drink:'d',diet:'e',budget:'b'};
  const QUESTION_KEYS=['occasion','people','time','vibe','drink','diet','budget'];
  const GROUP_LABELS={produce:'Obst und Gemüse',cooling:'Kühlung',pantry:'Vorrat',drinks:'Getränke',optional:'optional'};
  const GROUP_ORDER=['produce','cooling','pantry','drinks','optional'];
  const BASE_SERVINGS=4;
  const DRINK_CATEGORY={
    'focaccia-burrata-aperitivo':'aperitivo',
    'tomato-burrata-table':'wine',
    'grilled-peach-table':'wine',
    'sage-lemon-aperitivo':'cocktail',
    'amalfi-lemon-pasta':'cocktail',
    'crispy-gnocchi-tomato':'beer',
    'mediterranean-mezze-night':'aperitivo',
    'date-night-pasta-limone':'cocktail',
    'lemon-white-bean-bruschetta':'wine',
    'hummus-crunch-flatbreads':'beer',
    'tomato-basil-spaghetti':'wine',
    'sunday-brunch-focaccia-eggs':'cocktail',
    'berry-ricotta-brunch':'alcoholfree',
    'morning-after-crispy-potatoes':'alcoholfree',
    'green-shakshuka-brunch':'cocktail',
    'tuscan-white-bean-table':'wine',
    'roast-pepper-orzo-table':'wine',
    'midnight-chicken-flatbread':'beer',
    'smashed-cucumber-sesame-noodles':'cocktail',
    'harissa-chickpea-tray':'aperitivo',
    'burrata-pesto-orzo':'wine',
    'crispy-taco-table':'beer',
    'lemon-herb-chicken-tray':'wine',
    'mushroom-butter-toast':'wine',
    'baked-feta-tomato-beans':'aperitivo',
    'miso-butter-corn-ramen':'beer',
    'brunch-breakfast-tacos':'cocktail',
    'french-toast-orange':'cocktail',
    'spicy-vodka-rigatoni':'cocktail',
    'falafel-crunch-table':'aperitivo'
  };
  const DRINK_FALLBACKS={
    aperitivo:{name:'Aperitivo & Soda',ingredients:[{group:'drinks',name:'Aperitivo bitter',qty:160,unit:'ml'},{group:'drinks',name:'Soda',qty:240,unit:'ml'},{group:'produce',name:'Orange',qty:1,unit:'Stk.',whole:true},{group:'optional',name:'Eis',qty:400,unit:'g'}],steps:['Gläser mit Eis füllen und pro Person 40 ml Aperitivo hineingeben.','Pro Person 60 ml Soda aufgießen, kurz rühren und mit Orange servieren.']},
    cocktail:{name:'Weekend Gin Highball',ingredients:[{group:'drinks',name:'Gin',qty:120,unit:'ml'},{group:'produce',name:'Zitronensaft',qty:80,unit:'ml'},{group:'drinks',name:'Soda',qty:400,unit:'ml'},{group:'optional',name:'Eis',qty:400,unit:'g'}],steps:['Gläser mit Eis füllen und pro Person 30 ml Gin sowie 20 ml Zitronensaft hineingeben.','Pro Person 100 ml Soda aufgießen, 5 Sekunden rühren und mit Zitronenzeste servieren.']},
    wine:{name:'Chilled House Wine',ingredients:[{group:'drinks',name:'Trockener Wein',qty:600,unit:'ml'}],steps:['Wein passend zum Essen auf 8–10 °C für Weißwein oder 14–16 °C für leichten Rotwein vorkühlen.','Pro Person etwa 150 ml zum Essen einschenken.']},
    beer:{name:'Cold Lager',ingredients:[{group:'drinks',name:'Lager',qty:1320,unit:'ml'}],steps:['Lager mindestens 3 Stunden kalt stellen.','Pro Person etwa 330 ml unmittelbar zum Essen öffnen und sehr kalt servieren.']}
  };

  function init(root){
    if(!root || root.dataset.wcTableReady==='true') return;
    root.dataset.wcTableReady='true';
    const form=root.querySelector('[data-wc-table-form]');
    const results=root.querySelector('[data-wc-table-results]');
    const grid=root.querySelector('[data-wc-table-grid]');
    const status=root.querySelector('[data-wc-table-status]');
    const summary=root.querySelector('[data-wc-table-summary]');
    const bar=root.querySelector('[data-wc-table-progress-bar]');
    const progressLabel=root.querySelector('[data-wc-table-progress-label]');
    const exactWrap=root.querySelector('[data-wc-table-exact-wrap]');
    const exactGrid=root.querySelector('[data-wc-table-exact-grid]');
    if(!form || !results || !grid) return;
    let cycle=0;
    let lastAnswers=null;

    restoreFromUrl(form, exactWrap, exactGrid);
    updateProgress(form,bar,progressLabel);

    form.addEventListener('change',function(e){
      if(e.target && e.target.name==='people_band'){
        renderExactPeople(form,e.target.value,exactWrap,exactGrid);
      }
      updateProgress(form,bar,progressLabel);
    });

    form.addEventListener('submit',function(e){
      e.preventDefault();
      const answers=getAnswers(form);
      const missing=missingQuestions(answers);
      if(missing.length){
        status.textContent=missing[0]==='people'?'Bitte wähle bei Frage 02 die genaue Personenzahl.':'Bitte beantworte alle sieben Fragen.';
        const first=missing[0]==='people'?form.querySelector('[name="people_band"]'):form.querySelector('[name="'+missing[0]+'"]');
        if(first) first.focus();
        return;
      }
      status.textContent='';
      cycle=0;
      lastAnswers=answers;
      renderResults(root,grid,results,summary,answers,cycle,true);
      writeUrl(answers);
      requestAnimationFrame(()=>results.scrollIntoView({behavior:prefersReduced()?'auto':'smooth',block:'start'}));
    });

    root.addEventListener('click',async function(e){
      const copy=e.target.closest('[data-wc-table-copy]');
      if(copy){
        const plan=DATA.find(p=>p.id===copy.dataset.wcTableCopy);
        if(plan && lastAnswers) await copyShopping(plan,lastAnswers,copy);
        return;
      }
      const share=e.target.closest('[data-wc-table-share]');
      if(share){
        const plan=DATA.find(p=>p.id===share.dataset.wcTableShare);
        if(plan && lastAnswers) await sharePlan(plan,lastAnswers,share);
        return;
      }
      const other=e.target.closest('[data-wc-table-other]');
      if(other && lastAnswers){
        cycle++;
        renderResults(root,grid,results,summary,lastAnswers,cycle,true);
        requestAnimationFrame(()=>results.scrollIntoView({behavior:prefersReduced()?'auto':'smooth',block:'start'}));
        return;
      }
      const restart=e.target.closest('[data-wc-table-restart]');
      if(restart){
        form.reset();
        exactWrap.hidden=true;
        exactGrid.innerHTML='';
        results.hidden=true;
        grid.innerHTML='';
        status.textContent='';
        lastAnswers=null;
        cycle=0;
        clearUrl();
        updateProgress(form,bar,progressLabel);
        form.scrollIntoView({behavior:prefersReduced()?'auto':'smooth',block:'start'});
        return;
      }
      const edit=e.target.closest('[data-wc-table-edit]');
      if(edit){
        form.scrollIntoView({behavior:prefersReduced()?'auto':'smooth',block:'start'});
      }
    });

    const restored=getAnswers(form);
    if(!missingQuestions(restored).length){
      lastAnswers=restored;
      renderResults(root,grid,results,summary,restored,0,false);
    }
  }

  function missingQuestions(a){
    return QUESTION_KEYS.filter(k=>!a[k]);
  }

  function getAnswers(form){
    const out={};
    ['occasion','time','vibe','drink','diet','budget'].forEach(k=>{
      const el=form.querySelector('[name="'+k+'"]:checked');
      out[k]=el?el.value:'';
    });
    const band=form.querySelector('[name="people_band"]:checked');
    out.peopleBand=band?band.value:'';
    const people=form.querySelector('[name="people"]:checked');
    out.people=people?parseInt(people.value,10):0;
    return out;
  }

  function renderExactPeople(form,band,wrap,grid,selected){
    if(!wrap || !grid) return;
    const ranges={p2:[2],p34:[3,4],p56:[5,6],p710:[7,8,9,10]};
    const values=ranges[band]||[];
    grid.innerHTML=values.map(n=>'<label class="wc-table__choice wc-table__choice--mini"><input type="radio" name="people" value="'+n+'"'+(String(n)===String(selected)?' checked':'')+'><span>'+n+'</span></label>').join('');
    wrap.hidden=!values.length;
    if(values.length===1){
      const only=grid.querySelector('input');
      if(only) only.checked=true;
    }
  }

  function updateProgress(form,bar,label){
    const a=getAnswers(form);
    let count=0;
    if(a.occasion) count++;
    if(a.people) count++;
    if(a.time) count++;
    if(a.vibe) count++;
    if(a.drink) count++;
    if(a.diet) count++;
    if(a.budget) count++;
    if(bar) bar.style.width=(count/7*100)+'%';
    if(label) label.textContent=count+' / 7 beantwortet';
  }

  function isHardConflict(p,a){
    if(!a || !a.people || a.people<2 || a.people>10) return true;
    if(p.totalTime>TIME_CAP[a.time]) return true;
    if(BUDGET_CAP[a.budget]<999 && p.budgetHigh>BUDGET_CAP[a.budget]) return true;
    if(a.diet==='vegan' && p.diet!=='vegan') return true;
    if(a.diet==='vegetarian' && p.diet==='omnivore') return true;
    if(a.diet==='lactose_low' && !(p.lactoseLow || p.diet==='vegan')) return true;
    if((a.drink==='alcoholfree' || a.diet==='no_alcohol') && !p.naDrink) return true;
    return false;
  }

  function scorePlan(p,a){
    if(isHardConflict(p,a)) return null;
    let s=0;
    s += p.occasions.includes(a.occasion) ? 24 : 8;
    if(a.vibe==='surprise') s += p.vibes.includes('surprise') ? 20 : 14;
    else s += p.vibes.includes(a.vibe) ? 20 : 6;
    if(a.drink==='open') s += 12;
    else if(a.drink==='alcoholfree' || a.diet==='no_alcohol') s += 16;
    else s += p.drinkCats.includes(a.drink) ? 16 : 5;
    if(a.diet==='none' || a.diet==='no_alcohol') s += 12;
    else if(a.diet==='vegan' && p.diet==='vegan') s += 12;
    else if(a.diet==='vegetarian' && (p.diet==='vegetarian'||p.diet==='vegan')) s += 12;
    else if(a.diet==='lactose_low' && (p.lactoseLow||p.diet==='vegan')) s += 12;
    const tc=TIME_CAP[a.time];
    if(tc===999) s += p.totalTime<=30 ? 9 : 7;
    else {
      const gap=tc-p.totalTime;
      s += gap<=5 ? 10 : gap<=15 ? 8 : 6;
    }
    const bc=BUDGET_CAP[a.budget];
    if(bc===999) s += 8;
    else s += p.budgetHigh<=bc*0.75 ? 10 : 8;
    if(a.people===2 && a.occasion==='date') s += p.occasions.includes('date') ? 4 : 2;
    else if(a.people>=5) s += p.vibes.includes('sharing') ? 4 : 3;
    else s += 3;
    s += p.difficulty===1 ? 4 : 3;
    return Math.max(0,Math.min(100,s));
  }

  function rankedPlans(a){
    return DATA.map(p=>({plan:p,score:scorePlan(p,a)}))
      .filter(x=>x.score!==null)
      .sort((x,y)=>y.score-x.score || x.plan.priority-y.plan.priority || x.plan.id.localeCompare(y.plan.id));
  }

  function chooseResults(a,cycle){
    const ranked=rankedPlans(a);
    if(!ranked.length) return [];
    const start=(cycle*3)%ranked.length;
    const ordered=ranked.slice(start).concat(ranked.slice(0,start));
    const best=ordered[0];
    let easy=ordered.slice(1).find(x=>x.plan.difficulty<=best.plan.difficulty && x.plan.totalTime<=best.plan.totalTime+5) || ordered[1];
    const used=new Set([best&&best.plan.id,easy&&easy.plan.id].filter(Boolean));
    let wildcard=ordered.find(x=>{
      if(used.has(x.plan.id)) return false;
      const vibeContrast=a.vibe!=='surprise' && !x.plan.vibes.includes(a.vibe);
      const formatContrast=best && (x.plan.diet!==best.plan.diet || Math.abs(x.plan.totalTime-best.plan.totalTime)>=10);
      return (vibeContrast||formatContrast) && x.score>=45;
    }) || ordered.find(x=>!used.has(x.plan.id));
    return [best,easy,wildcard].filter(Boolean);
  }

  function renderResults(root,grid,results,summary,a,cycle,announce){
    const picks=chooseResults(a,cycle);
    const ranks=['BEST MATCH','EASY ALTERNATIVE','WILDCARD'];
    grid.innerHTML=picks.map((x,i)=>cardHtml(x.plan,x.score,ranks[i],a,i===0)).join('');
    if(summary) summary.textContent=LABELS.occasion[a.occasion]+' · '+a.people+' Personen · '+LABELS.vibe[a.vibe]+' · '+LABELS.budget[a.budget];
    results.hidden=false;
    if(announce){
      const live=root.querySelector('[data-wc-table-live]');
      if(live) live.textContent='Drei passende Table Plans wurden erstellt.';
    }
  }

  function cardHtml(p,score,rank,a,top){
    const noAlcohol=a.drink==='alcoholfree'||a.diet==='no_alcohol';
    const drinkChoice=drinkSelection(p,a);
    const primaryDrink=drinkChoice.name;
    const ingredients=shoppingIngredients(p,a.people,drinkChoice.ingredients);
    const foodIngredients=(p.ingredients||[]).map(i=>scaleIngredient(i,a.people));
    const selectedDrinkIngredients=drinkChoice.ingredients.map(i=>scaleIngredient(i,a.people));
    const alternativeIngredients=(p.naDrinkIngredients||[]).map(i=>scaleIngredient(i,a.people));
    const grouped=groupIngredients(ingredients);
    const tags=[a.people+' Personen',p.totalTime+' Min.',p.diet==='vegan'?'vegan':p.diet==='vegetarian'?'vegetarisch':'omnivore',noAlcohol?'0.0 Drink':LABELS.drink[a.drink]];
    const recipe=p.recipe?'<div class="wc-table__recipe"><strong>PASSENDES WEEKEND RECIPE</strong><span>'+esc(p.recipe.title)+'</span><a href="'+esc(p.recipe.url)+'">REZEPT VOLLSTÄNDIG ÖFFNEN →</a></div>':'';
    const equipment=(p.equipment||[]).length?'<section><h4>DAS BRAUCHST DU</h4><ul>'+p.equipment.map(item=>'<li>'+esc(item)+'</li>').join('')+'</ul></section>':'';
    const makeAhead=p.makeAhead?'<section><h4>VORBEREITEN</h4><p>'+esc(p.makeAhead)+'</p></section>':'';
    const serving=p.serving?'<section><h4>SERVIEREN</h4><p>'+esc(p.serving)+'</p></section>':'';
    const alternative=(noAlcohol||drinkChoice.category==='alcoholfree')?'':'<section><h4>ALKOHOLFREIE ALTERNATIVE</h4><p><strong>'+esc(p.naDrink)+'</strong></p><ul>'+alternativeIngredients.map(i=>'<li><strong>'+esc(i.amount)+'</strong> '+esc(i.name)+'</li>').join('')+'</ul><ol>'+((p.naDrinkSteps)||[]).map(s=>'<li>'+esc(s)+'</li>').join('')+'</ol></section>';
    const details='<details class="wc-table__details"><summary>VOLLSTÄNDIGEN TABLE PLAN ANSEHEN</summary><div class="wc-table__details-body">'+
      '<section><h4>FOOD-ZUTATEN · '+a.people+' PERSONEN</h4><ul>'+foodIngredients.map(i=>'<li><strong>'+esc(i.amount)+'</strong> '+esc(i.name)+(i.note?' <small>'+esc(i.note)+'</small>':'')+'</li>').join('')+'</ul></section>'+
      '<section><h4>'+esc(primaryDrink).toUpperCase()+' · ZUTATEN</h4><ul>'+selectedDrinkIngredients.map(i=>'<li><strong>'+esc(i.amount)+'</strong> '+esc(i.name)+(i.note?' <small>'+esc(i.note)+'</small>':'')+'</li>').join('')+'</ul></section>'+
      '<section><h4>EINKAUFSLISTE</h4>'+shoppingHtml(grouped)+'</section>'+
      equipment+makeAhead+
      '<section><h4>CHRONOLOGISCHE ZUBEREITUNG</h4><ol>'+p.steps.map(s=>'<li>'+esc(s)+'</li>').join('')+'</ol></section>'+
      '<section><h4>DRINK-ZUBEREITUNG</h4><ol>'+drinkChoice.steps.map(s=>'<li>'+esc(s)+'</li>').join('')+'</ol></section>'+
      serving+alternative+
      '<section><h4>HOSTING-TIPP</h4><p>'+esc(p.hostTip)+'</p></section>'+recipe+
      '</div></details>';
    return '<article class="wc-table__card'+(top?' wc-table__card--top':'')+'" data-table-id="'+esc(p.id)+'">'+
      '<div class="wc-table__card-top"><div><p class="wc-table__rank">'+rank+'</p><h3>'+esc(p.name)+'</h3></div><div class="wc-table__score"><strong>'+score+'%</strong><span>Match</span></div></div>'+
      '<div class="wc-table__tags">'+tags.map(t=>'<span class="wc-table__tag">'+esc(t)+'</span>').join('')+'</div>'+
      '<p class="wc-table__why"><strong>Warum er passt.</strong> '+esc(p.reason)+'</p>'+
      '<div class="wc-table__menu">'+
        '<div><span>FOOD</span><strong>'+esc(p.food)+'</strong></div>'+
        '<div><span>MAIN</span><strong>'+esc(p.main)+'</strong></div>'+
        '<div><span>DRINK</span><strong>'+esc(primaryDrink)+'</strong></div>'+
        '<div><span>TABLE DETAIL</span><strong>'+esc(p.tableDetail)+'</strong></div>'+
      '</div>'+
      '<div class="wc-table__facts"><div><span>VORBEREITUNG</span><strong>'+esc(p.prep)+'</strong></div><div><span>BUDGET</span><strong>ca. '+p.budgetLow+'–'+p.budgetHigh+' € p.P.</strong></div><div><span>SCHWIERIGKEIT</span><strong>'+difficultyLabel(p.difficulty)+'</strong></div></div>'+
      details+
      '<div class="wc-table__actions"><button type="button" class="wc-table__action wc-table__action--primary" data-wc-table-copy="'+esc(p.id)+'">EINKAUFSLISTE KOPIEREN</button><button type="button" class="wc-table__action" data-wc-table-share="'+esc(p.id)+'">MIT DER CREW TEILEN</button></div>'+
      '</article>';
  }

  function drinkSelection(p,a){
    if(a.drink==='alcoholfree'||a.diet==='no_alcohol') return {name:p.naDrink,ingredients:p.naDrinkIngredients||[],steps:p.naDrinkSteps||[],category:'alcoholfree'};
    if(a.drink==='open'||DRINK_CATEGORY[p.id]===a.drink) return {name:p.drink,ingredients:p.drinkIngredients||[],steps:p.drinkSteps||[],category:DRINK_CATEGORY[p.id]};
    const fallback=DRINK_FALLBACKS[a.drink];
    if(fallback&&p.drinkCats.includes(a.drink)) return {name:fallback.name,ingredients:fallback.ingredients,steps:fallback.steps,category:a.drink};
    return {name:p.drink,ingredients:p.drinkIngredients||[],steps:p.drinkSteps||[],category:DRINK_CATEGORY[p.id]};
  }

  function shoppingIngredients(p,people,drinkIngredients){
    const all=(p.ingredients||[]).concat(drinkIngredients||[]);
    const scaled=all.map(i=>scaleIngredient(i,people));
    const map=new Map();
    scaled.forEach(i=>{
      const key=i.group+'|'+i.name+'|'+i.unit;
      if(!map.has(key)) map.set(key,Object.assign({},i,{rawQty:i.rawQty}));
      else {
        const x=map.get(key);
        x.rawQty+=i.rawQty;
        x.amount=formatQty(x.rawQty,x.unit,x.whole);
      }
    });
    return Array.from(map.values());
  }

  function scaleIngredient(i,people){
    const raw=(Number(i.qty)||0)/BASE_SERVINGS*people;
    return {group:i.group,name:i.name,unit:i.unit,whole:!!i.whole,note:i.note||'',rawQty:raw,amount:formatQty(raw,i.unit,!!i.whole)};
  }

  function formatQty(q,unit,whole){
    let n;
    if(whole) n=Math.ceil(q-1e-9);
    else if(unit==='g'||unit==='ml') n=q<20?Math.round(q):Math.round(q/5)*5;
    else n=Math.round(q*2)/2;
    const display=(Number.isInteger(n)?String(n):String(n).replace('.',','));
    return display+' '+unitLabel(unit,n);
  }

  function unitLabel(unit,n){
    if(n!==1) return unit;
    return {Kugeln:'Kugel',Scheiben:'Scheibe',Zehen:'Zehe',Zweige:'Zweig',Blätter:'Blatt'}[unit]||unit;
  }

  function groupIngredients(items){
    const groups={}; GROUP_ORDER.forEach(g=>groups[g]=[]);
    items.forEach(i=>{(groups[i.group]||(groups[i.group]=[])).push(i);});
    return groups;
  }

  function shoppingHtml(groups){
    return GROUP_ORDER.map(g=>{
      if(!groups[g]||!groups[g].length) return '';
      return '<div class="wc-table__shopping-group"><strong>'+GROUP_LABELS[g]+'</strong><ul>'+groups[g].map(i=>'<li>'+esc(i.amount)+' '+esc(i.name)+'</li>').join('')+'</ul></div>';
    }).join('');
  }

  function shoppingText(p,a){
    const drinkChoice=drinkSelection(p,a);
    const groups=groupIngredients(shoppingIngredients(p,a.people,drinkChoice.ingredients));
    const lines=['EINKAUFSLISTE · '+p.name,'Für '+a.people+' Personen',''];
    GROUP_ORDER.forEach(g=>{
      const arr=groups[g]||[]; if(!arr.length) return;
      lines.push(GROUP_LABELS[g].toUpperCase());
      arr.forEach(i=>lines.push('• '+i.amount+' '+i.name));
      lines.push('');
    });
    return lines.join('\n').trim();
  }

  async function copyShopping(p,a,button){
    try{
      await copyText(shoppingText(p,a));
      flash(button,'KOPIERT','EINKAUFSLISTE KOPIEREN');
    }catch(e){ flash(button,'KOPIEREN NICHT MÖGLICH','EINKAUFSLISTE KOPIEREN'); }
  }

  async function sharePlan(p,a,button){
    const primaryDrink=drinkSelection(p,a).name;
    const text='Unser Weekend Table: '+p.food+' → '+p.main+' → '+primaryDrink+'. Erstellt mit The Table von Weekend Culture.';
    const url=shareUrl();
    try{
      if(navigator.share){
        await navigator.share({title:'Weekend Culture · The Table',text:text,url:url});
        flash(button,'GETEILT','MIT DER CREW TEILEN');
      }else{
        await copyText(text+'\n'+window.location.origin+'/pages/weekend-table');
        flash(button,'KOPIERT','MIT DER CREW TEILEN');
      }
    }catch(err){
      if(err&&err.name==='AbortError') return;
      try{await copyText(text+'\n'+window.location.origin+'/pages/weekend-table');flash(button,'KOPIERT','MIT DER CREW TEILEN');}catch(e){}
    }
  }

  function shareUrl(){
    try{
      const u=new URL(window.location.href);
      u.hash='';
      return u.toString();
    }catch(e){return window.location.href;}
  }

  function flash(button,text,back){
    if(!button) return;
    button.textContent=text;
    window.setTimeout(()=>button.textContent=back,1600);
  }

  async function copyText(text){
    if(navigator.clipboard&&window.isSecureContext) return navigator.clipboard.writeText(text);
    const ta=document.createElement('textarea');
    ta.value=text; ta.setAttribute('readonly',''); ta.style.position='fixed'; ta.style.opacity='0';
    document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove();
  }

  function difficultyLabel(n){return n===1?'easy':n===2?'easy +':'weekend project';}

  function writeUrl(a){
    try{
      const u=new URL(window.location.href);
      Object.keys(URL_KEYS).forEach(k=>u.searchParams.set(URL_KEYS[k],a[k]));
      history.replaceState({},'',u);
    }catch(e){}
  }
  function clearUrl(){
    try{
      const u=new URL(window.location.href);
      Object.values(URL_KEYS).forEach(k=>u.searchParams.delete(k));
      history.replaceState({},'',u.pathname+u.search+u.hash);
    }catch(e){}
  }
  function restoreFromUrl(form,wrap,grid){
    try{
      const u=new URL(window.location.href);
      ['occasion','time','vibe','drink','diet','budget'].forEach(k=>{
        const v=u.searchParams.get(URL_KEYS[k]); if(!v) return;
        const input=form.querySelector('[name="'+k+'"][value="'+cssEscape(v)+'"]');
        if(input) input.checked=true;
      });
      const n=parseInt(u.searchParams.get(URL_KEYS.people)||'',10);
      if(n>=2&&n<=10){
        const band=n===2?'p2':n<=4?'p34':n<=6?'p56':'p710';
        const bandInput=form.querySelector('[name="people_band"][value="'+band+'"]');
        if(bandInput){bandInput.checked=true;renderExactPeople(form,band,wrap,grid,n);}
      }
    }catch(e){}
  }

  function cssEscape(v){return String(v).replace(/["\\]/g,'\\$&');}
  function esc(v){return String(v==null?'':v).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));}
  function prefersReduced(){return window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;}
  function boot(scope){(scope||document).querySelectorAll('[data-wc-table-root]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>boot(document)); else boot(document);
  document.addEventListener('shopify:section:load',e=>boot(e.target));

  window.WCTableTool={data:DATA,hardConflict:isHardConflict,score:scorePlan,ranked:rankedPlans,choose:chooseResults,scaleIngredient:scaleIngredient};
})();
